<template>
  <v-row>
    <v-col cols="4" v-for="item in items" :key="item.key">
      <v-card
        :style="{ backgroundColor: item.bg }"
        class="pa-4 text-center"
        flat
      >
        <div
          class="text-h4 font-weight-bold"
          :style="{ color: item.color }"
        >
          {{ stats[item.key] || 0 }}
        </div>
        <div
          class="subtitle-1 mt-1"
          :style="{ color: item.color }"
        >
          {{ $t(item.i18nKey) }}
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'OrderDispatchStatsCards',

  props: {
    stats: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    items: [
      {
        key: 'daAssegnare',
        bg: '#fff3e0',
        color: '#e65100',
        i18nKey: 'dispatch.stats.unassigned',
      },
      {
        key: 'rifiutati',
        bg: '#fce4ec',
        color: '#c62828',
        i18nKey: 'dispatch.stats.rejected',
      },
      {
        key: 'assegnatiOggi',
        bg: '#e8f5e9',
        color: '#2e7d32',
        i18nKey: 'dispatch.stats.assignedToday',
      },
    ],
  }),
};
</script>
